// core
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor() { }

  setCustomerToken(token: string) {
    window.sessionStorage.setItem('customerToken', token);
  }

  getCustomerToken() {
    return window.sessionStorage.getItem('customerToken');
  }

  setToken(token: string) {
    window.sessionStorage.setItem('token', token);
  }

  getToken() {
    return window.sessionStorage.getItem('token');
  }

  clearToken() {
    window.sessionStorage.removeItem('token');
  }

  setApiKey(apiKey: string) {
    window.sessionStorage.setItem('apiKey', apiKey);
  }

  getApiKey() {
    return window.sessionStorage.getItem('apiKey');
  }

  public endSession() {
    // TODO: will also delete the user object if this is where I end up storing it
    window.sessionStorage.removeItem('token');
    window.sessionStorage.removeItem('user');
    window.sessionStorage.removeItem('clientId');
  }

  setUnAuthenticatedUser(data: any) {
    window.sessionStorage.setItem('unAuthenticatedUser', data);
  }

  isAuthenticated() {
    const token = this.getToken();
    let customerRefExists;
    let partnerSlugExists;
    let usernameExists;
    let authenticated;

    // This is used to verify Auth0 token
    let userIdentityExists;

    if (token != null) {
      const tokenPayload = token.split('.')[1];

      // decode the tokenPayload
      // Sometimes encoded token sent from BE can have an underscore
      //  but browser expects a forward slash '/'
      // Reference: https://datatracker.ietf.org/doc/html/rfc4648#section-5
      const decodedPayload = JSON.parse(atob(tokenPayload.replace('_', '/')));

      customerRefExists = decodedPayload.customer_ref != null
      partnerSlugExists = decodedPayload.partner_slug != null
      usernameExists = decodedPayload.username != null
      userIdentityExists = decodedPayload.sub != null

      // A user can be considered authenticated if either:
      //  - customer ref and partner slug exists in jwt token
      //  - username exists in jwt token
      //  - auth0 user email id exists in Auth0 jwt token
      authenticated = ((customerRefExists && partnerSlugExists) || usernameExists || userIdentityExists);
    } else {
      authenticated = false;
    }

    return authenticated;
  }

  // Returns user Slug if available
  getLoggedInUser() {
    let customerRef = '';
    const token = this.getToken();

    if (token != null) {
      const tokenPayload = token.split('.')[1];

      // decode the tokenPayload
      // Sometimes encoded token sent from BE can have an underscore
      //  but browser expects a forward slash '/'
      // Reference: https://datatracker.ietf.org/doc/html/rfc4648#section-5
      const decodedPayload = JSON.parse(atob(tokenPayload.replace('_', '/')));

      customerRef = decodedPayload.customer_ref;
    }

    return customerRef;
  }
}
